const getCategoryId = (brands) => {
  const categoryIds = [brands.categoryId, brands.subCategory1Id, brands.subCategory2Id].filter(
    (catId) => catId
  );
  return categoryIds.slice(-1)[0];
};
export default getCategoryId;
